<template>
  <div class="page">
    <!-- 头部 -->
    <Header></Header>
    <!-- 新闻列表 -->
    <div class="news">
      <ul class="infiniteUl" id="refreshScroll">
        <nut-infiniteloading
          pull-icon="refresh"
          container-id="refreshScroll"
          :is-open-refresh="true"
          :has-more="refreshHasMore"
          load-icon='more-x'
          @load-more="refreshLoadMore"
          @refresh="refresh">
          <li
            class="infiniteLi"
            v-for="(item, index) in articleList"
            :key="index">
            <router-link :to=" { path:'/newsDetails', query: {id: item.id} } ">
              <div class="news_item">
                <img :src="item.image" alt="">
                <div class="news_info">
                  <p class="news_title">{{ item.topic }}</p>
                  <p class="news_date">{{ item.createTime }}</p>
                  <p class="news_desc">{{ item.description }}</p>
                </div>
              </div>
            </router-link>


            </li>
        </nut-infiniteloading>
      </ul>
    </div>
    <!-- 底部 -->
    <!-- <Footer></Footer> -->
  </div>
</template>
<script>
import Footer from "@/components/page/Footer.vue";
import Header from "@/components/page/Header.vue";
import { Toast } from '@nutui/nutui';
import { getArticleList } from "@/api/app.js";
export default {
  components: {
    Footer,
    Header
  },
  data() {
    return {
      refreshHasMore: true,
      queryParams: {
        limit: 10,
        page: 1
      },
      articleList: [],
    }
  },
  created() {
    this.init();
  },
  methods: {
    // 初始化
    init() {
      // this.articleList = [];
      getArticleList(this.queryParams).then(res => {
        this.articleList = this.articleList.concat(res.list);
        if (this.articleList.length >= res.total) this.refreshHasMore = false
      });
    },
    // 下拉刷新
    refresh(done) {
      setTimeout(()=>{
        // Toast.success('刷新成功');
        this.queryParams.page = 1;
        this.refreshHasMore = true;
        this.articleList = [];
        this.init()
        done();
      },1000)
    },
    // 加载更多
    refreshLoadMore(done) {
      setTimeout(() => {
        this.queryParams.page ++;
        this.init();
        done()
      }, 500);
    },
  },
}
</script>
<style scoped>
.infiniteUl {
  width: 100%;
  padding: 0;
  margin: 0;
  overflow-y: auto;
  overflow-x: hidden;
}
.page .news {
  margin-top: 125px;
  padding: 0 32px;
  box-sizing: border-box;
  margin-bottom: 40px;
}
.news_item {
  margin-bottom: 30px;
  background: #f8f8f8;
  height: 670px;
}
.news_item img {
  display: block;
  width: 686px;
  height: 350px;
}
.news_item .news_info {
  padding: 20px;
  box-sizing: border-box;
}
.news_item .news_info .news_title {
  font-size: 32px;
  font-weight: 700;
  color: #333333;
  text-align: justify;
  word-break: break-all;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.news_item .news_info .news_date {
  margin-top: 10px;
  font-size: 24px;
  color: #333333;
}
.news_item .news_info .news_desc {
  margin-top: 15px;
  font-size: 24px;
  color: #666666;
  text-align: justify;
  word-break: break-all;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}


</style>